export const CLASS_NAMES = {
  container: 'flex w-full',
};

export const PLACE_HOLDER_PROPS = {
  link: {
    target: '_black',
    href: `https://storage.googleapis.com/ideal-terms/checkout%20T%26C's%20Website%20%2B%20Service.pdf`,
    className: 'text-purple-200',
  },
};

export const VALIDATION_MESSAGE =
  "You must accept Kanda's Terms and Conditions of Service";
